// extracted by mini-css-extract-plugin
export default {"drawerContainer":"NZ92Y","labelContainer":"IPjzb","label":"uZaiL","labelIcon":"EXTsC"};